// extracted by mini-css-extract-plugin
export var mt0 = "widget-share-module--mt-0--968d8";
export var mt1 = "widget-share-module--mt-1--f05cb";
export var mt2 = "widget-share-module--mt-2--05861";
export var mt3 = "widget-share-module--mt-3--3bf0b";
export var mt4 = "widget-share-module--mt-4--ca3ce";
export var mt5 = "widget-share-module--mt-5--0d721";
export var mt6 = "widget-share-module--mt-6--2e2ed";
export var widgetShare = "widget-share-module--widget-share--83517";
export var widgetShareTitle = "widget-share-module--widget-share--title--3fac6";
export var widgetShare__item = "widget-share-module--widget-share__item--c22b9";
export var widgetShare__item__icon = "widget-share-module--widget-share__item__icon--eaeed";
export var widgetShare__item__link = "widget-share-module--widget-share__item__link--a80f1";
export var widgetShare__item__notification = "widget-share-module--widget-share__item__notification--c555c";
export var widgetShare__list = "widget-share-module--widget-share__list--8583a";
export var widgetShare__title = "widget-share-module--widget-share__title--48999";